module.exports = __webpack_public_path__ + "img/security-scan.2d0d4fcf.svg";